export enum TimeUnit {
    HOUR,
    MINUTE
}
